module.exports = __webpack_public_path__ + "media/images/talent/case5-icon01-f12b026b56a1adeb8244b41d2026b4fd.png";